import { X, Check } from 'lucide-react';
import { useTranslation } from '@/i18n/i18n';

export const PainSection = () => {
  const { t } = useTranslation();

  const beforeItems = [t('pain.before1'), t('pain.before2'), t('pain.before3'), t('pain.before4')];

  const afterItems = [
    t('pain.after1'),
    t('pain.after2'),
    t('pain.after3'),
    t('pain.after4'),
    t('pain.after5'),
  ];

  return (
    <section className="py-12 px-6 md:px-8 bg-card">
      <div className="max-w-6xl mx-auto">
        {/* Section header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-semibold mb-6 tracking-tight">
            {t('pain.heading')
              .split('<bold>')
              .map((part, i) => {
                if (i === 0) return part;
                const [bold, rest] = part.split('</bold>');
                return (
                  <span key={bold}>
                    <span className="font-extrabold">{bold}</span>
                    {rest}
                  </span>
                );
              })}
          </h2>
          <p className="text-xl text-muted-foreground max-w-3xl mx-auto">{t('pain.subheading')}</p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 lg:gap-12">
          {/* Before - Traditional accounting */}
          <div className="p-8 lg:p-10 rounded-2xl bg-muted/40 border border-border">
            <div className="flex items-center gap-4 mb-8">
              <X className="size-6 text-muted-foreground/60" aria-hidden="true" />
              <h3 className="text-xl lg:text-2xl font-semibold text-foreground">
                {t('pain.beforeTitle')}
              </h3>
            </div>
            <ul className="space-y-5">
              {beforeItems.map((item) => (
                <li key={item} className="flex items-start gap-4">
                  <X
                    className="size-4 text-muted-foreground/50 flex-shrink-0 mt-1"
                    aria-hidden="true"
                  />
                  <span className="text-foreground/70 leading-relaxed">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* After - Bookeper AI */}
          <div className="p-8 lg:p-10 rounded-2xl bg-card border border-foreground/20 relative overflow-hidden">
            <div className="relative">
              <div className="flex items-center gap-4 mb-8">
                <Check className="size-6 text-success" aria-hidden="true" />
                <h3 className="text-xl lg:text-2xl font-semibold text-foreground">
                  {t('pain.afterTitle')}
                </h3>
              </div>
              <ul className="space-y-5">
                {afterItems.map((item) => (
                  <li key={item} className="flex items-start gap-4">
                    <Check className="size-4 text-success flex-shrink-0 mt-1" aria-hidden="true" />
                    <span className="text-foreground/80 leading-relaxed">{item}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
